/**
 * Walk Store
 *
 * Zustand store for managing active walk state
 * Persisted to localStorage to survive navigation and page refresh
 */

import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface ActiveWalk {
  id: string;
  dogId: string;
  startTime: string; // ISO string for serialization
}

interface WalkState {
  activeWalk: ActiveWalk | null;
  startWalk: (dogId: string) => void;
  clearWalk: () => void;
  getStartTime: () => Date | null;
}

export const useWalkStore = create<WalkState>()(
  persist(
    (set, get) => ({
      activeWalk: null,

      startWalk: (dogId: string) =>
        set({
          activeWalk: {
            id: `walk-${Date.now()}`,
            dogId,
            startTime: new Date().toISOString(),
          },
        }),

      clearWalk: () => set({ activeWalk: null }),

      getStartTime: () => {
        const walk = get().activeWalk;
        return walk ? new Date(walk.startTime) : null;
      },
    }),
    {
      name: 'aiodog-walk',
    }
  )
);
